<template>
  <div class="b-page__tab">
    <div class="px-0 b-page__aside">
      <div class="py-4 px-6 b-counterparty-tab__aside-search">
        <input
          type="text"
          class="b-input"
          v-model="searchAssetQuery"
          :placeholder="$t('CONTENT.search')"/>
      </div>
      <div class="b-page__aside-list">
        <div v-for="(item, index) in filteredAssets" :key="index">
          <Sidebar :item="item"/>
        </div>
      </div>
    </div>
    <div class="b-page__content">
      <main class="b-main__inner">
        <div class="py-4 px-8 b-toolbar">
          <div class="b-toolbar__inner">
            <div class="mr-4 b-toolbar__item">
              <button data-cy="create-counterparty" class="b-btn b-btn_type_primary " @click="addAsset">
                <dynamic-icon class="b-btn__icon b-btn__icon_color_white" icon="plus" />
                {{$t('CONTENT.assets.create_asset')}}
              </button>
            </div>
            <div class="mr-4 b-toolbar__item">
              <button class="b-btn " @click="openImportDialog">
                <dynamic-icon class="b-btn__icon" icon="xls" />
                {{$t('CONTENT.import')}}
              </button>
            </div>
            <div class="mr-4 b-toolbar__item">
              <button class="b-btn  b-import__choose-btn" @click="downloadAssetTemplate">
                <dynamic-icon class="b-btn__icon b-btn__icon_color_white" icon="download"/>
                {{$t('CONTENT.download_template')}}
              </button>
            </div>

            <div class="b-toolbar__item">
              <button class="b-btn  b-import__choose-btn" @click="downloadAssets">
                <dynamic-icon class="b-btn__icon b-btn__icon_color_white" icon="download"/>
                {{$t('CONTENT.export')}}
              </button>
            </div>
          </div>
        </div>
        <server-error :error="error" />
        <ContentView
          v-if="getCurrentAssetIdInDB"
          :item="assetForContent"
          :is-read-only-mode="isReadOnlyMode"
          @edit="editHandler()"/>
        <popup name="asset-popup" height="auto" :scrollable="true">
          <server-error :error="error" />
          <div data-cy="form-label" class="b-dialog__top-panel">
            <h2>{{$t('CONTENT.assets.asset_create')}}</h2>
            <button class="b-btn b-btn_border_none" @click="closeAssetDialog">
              <dynamic-icon icon="close" />
            </button>
          </div>
          <CreateAsset
            v-if="isAssetShow"
            :asset="assetForForm"
            @closeDialog="closeAssetDialog"
          />
        </popup>
      </main>
    </div>
    <popup name="asset-import-popup" height="auto" :scrollable="true">
      <ImportDialogWidget v-if="isShowImportDialog" importType="asset" @close="closeImportDialog"></ImportDialogWidget>
    </popup>
  </div>
</template>
<script>
	import { mapGetters } from 'vuex';
	import CreateAsset from './edit/CreateAsset';
	import Sidebar from './Sidebar';
	import ContentView from './Content';
	import downloadFileMixin from '../../../mixins/downloadFile';
	import ImportDialogWidget from "../../widgets/ImportDialogWidget";
	import CreateAssetWidget from "../../widgets/CreateAssetWidget";
  import ButtonWithDropdown from "@/components/shared/ButtonWithDropdown.vue";

	const axios = require("axios");

	export default {
		components: {
      ButtonWithDropdown,
			CreateAsset,
			Sidebar,
			ContentView,
			ImportDialogWidget,
			CreateAssetWidget,
		},
    created() {
      this.role = localStorage.getItem('role');
      if (this.role === 'Admin') {
        this.isReadOnlyMode = false;
      }
    },
		data() {
			return {
				isAssetShow: false,
				error: null,
        isReadOnlyMode: true,
				assetForForm: null,
				isShowImportDialog: false,
				ifAssetCreateModal: false,
        searchAssetQuery: ''
			};
		},
		mixins: [downloadFileMixin],
		mounted() {
			this.onResize();
			window.addEventListener('resize', this.onResize);
		},
		computed: {
      ...mapGetters(['getAssets']),
      ...mapGetters(['getUnderlyingAssetTypes']),
      ...mapGetters(['getCurrentAssetIdInDB']),
      assetForContent() {
        this.$forceUpdate();
        return this.getAssets.find(x => x.idInDB === this.getCurrentAssetIdInDB)
      },
      filteredAssets() {
        if (this.searchAssetQuery === '') return this.getAssets
        const searchAssetQuery = this.searchAssetQuery.toLowerCase()
        return this.getAssets
          .filter(asset =>
            (asset.name && asset.name.toLowerCase().includes(searchAssetQuery)) ||
            (asset.externalId && asset.externalId.toLowerCase().includes(searchAssetQuery)) ||
            (asset.idInDB && asset.idInDB.toString().includes(searchAssetQuery))
          )
      },
    },

		methods: {
			onResize() {
        let pageTab = document.getElementsByClassName('b-main')[0];
        pageTab.classList.add('b-main_type_vh');

				let headerHeight = document.getElementsByClassName('b-header')[0].offsetHeight;
				let titleHeight = document.getElementsByClassName('b-section__title')[0].offsetHeight;
				let tabsListHeight = document.getElementsByClassName('b-tabs__list')[0].offsetHeight;
				// let searchHeight = document.getElementsByClassName('b-counterparty-tab__aside-search')[0].offsetHeight; //когда вернеться поиск, вернуть его в resultHeight
				let mainHeight = document.getElementsByClassName('b-main')[0].offsetHeight;
				let resultHeight = mainHeight - tabsListHeight - headerHeight - titleHeight;
				document.getElementsByClassName('b-page__aside-list')[0].style.height = `${resultHeight}px`;
			},
			closeCounterPartyDialog() {
				this.isAssetShow = false;
				this.assetForForm = null;
			},
			addLocalPersonForm() {
				this.isAssetShow = false;
				this.assetForForm = null;
				this.isAssetShow = true;
			},

			editHandler() {
				this.isAssetShow = false;
				this.assetForForm = this.assetForContent;
				this.isAssetShow = true;
        this.$modal.show('asset-popup');

      },
			downloadAssetTemplate() {
				this.importType = 'asset';
				this.downloadTemplate();
			},
      downloadAssets() {
        this.importType = 'allAssets';
        this.downloadTemplate();
      },
      openImportDialog() {
        this.isShowImportDialog = true;
        this.$modal.show('asset-import-popup');
      },
			async closeImportDialog() {
				await this.$store.dispatch("loadAllAssets");
				this.isShowImportDialog = false;
        this.$modal.hide('asset-import-popup');
			},
			addAsset() {
				this.isAssetShow = false;
				this.isAssetShow = true;
        this.$modal.show('asset-popup');
      },
			closeAssetDialog() {
				this.isAssetShow = false;
        this.assetForForm = null;
        this.$modal.hide('asset-popup');
      }
		},
		beforeDestroy() {
      let pageTab = document.getElementsByClassName('b-main')[0];
      pageTab.classList.remove('b-main_type_vh');
      window.removeEventListener('resize', this.onResize);
		}
	};
</script>
